import Vue from 'vue'
import Vuex from 'vuex'
import page from './modules/page'
import app from './modules/app'
import user from './modules/user'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    page,
    app,
    user
  },
  getters
})

export default store
